import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Image } from "antd";
import styles from "../../styles/dashboard.module.scss";
import BarChartHappiness from "../../components/StackedBarHappiness";
import StackedBarHappiness from "../../components/StackedBarHappiness";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";

export default function HappinessBarchart({ year }: any) {
  const { getUserByID } = useB2BContext();

  const [yearlyDepartmentIndexes, setYearlyDepartmentIndexes] = useState<any>();

  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyDepartmentIndexes({
          reportFor: "happiness",
        })
        .then((res: any) => {
          setYearlyDepartmentIndexes(res?.data?.data);
          console.log(res.data.data, "yearlyDepartmentIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        {/* <div className={styles.title_grp}>
          <Text className={styles.title}>Happiness Index</Text>
        </div> */}
        <div className="overview-card__header">
                  <div className="overview-card__title-row">
                    <span
                      className="overview-card__dot"
                      style={{ 
                        background:" rgb(246, 239, 86)",
                        boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.07)"
                       }}
                    />
                    <h3 className="overview-card__title">Happiness Index</h3>
                  </div>
                  <div className="overview-card__trend">
                    <Image src="/figma/up_arrow.svg" preview={false} width={14} />
                    <span>{yearlyDepartmentIndexes?.percentage || 0}% from last month</span>
                  </div>
                </div>
        <div className={styles.graph}>
          {yearlyDepartmentIndexes?.series.length === 0 ? (
            <div className="no_data_yet">
              <img src="/img/User_empty.png" alt="" width="56" height="52" />
              <p>No data yet</p>
            </div>
          ) : (
            <StackedBarHappiness chartData={yearlyDepartmentIndexes} />
          )}
        </div>
      </div>
    </div>
  );
}
